import React, { FC, useContext } from 'react';

import { cnListBoxItem, ListContext } from '../../ListBoxBase/utils';
import { IconArrowRight, IconOpenInNewTab } from '../../../icons';
import { useTheme } from '../../../lib/theme/ThemeProvider';

interface MenuIconProps {
    type: 'link' | 'subMenu';
    className?: string;
    'data-testid'?: string;
}

export const MenuIcon: FC<MenuIconProps> = props => {
    const { size } = useContext(ListContext);

    const { iconSize } = useTheme().sizeTokens[size];
    const className = cnListBoxItem('icon', { right: true }, [props.className]);
    const dataTestId = props['data-testid'];

    switch (props.type) {
        case 'link':
            return (
                <IconOpenInNewTab
                    className={className}
                    size={iconSize}
                    data-testid={dataTestId}
                    color="gray"
                    role="supplementary"
                />
            );
        case 'subMenu':
            return <IconArrowRight className={className} size={iconSize} data-testid={dataTestId} />;
    }
};
